import {useState, useEffect} from "react";
import Favicon from 'react-favicon';
import { useParams } from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import {config} from "./config.js";
import './App.css';
import ShipmentInfo from "./Components/ShipmentInfo.js";
import FlightDetails from "./Components/FlightDetails.js";
import Path from "./Components/Path.js";
import StatusInfo from "./Components/StatusInfo.js";
import FlightMap from "./Components/FlightMap.js";
import Search from "./Components/Search.js";
import Notification from "./Components/Notification.js";
import Subscribe from "./Components/Subscribe.js";

const Main = (props) => {
  const [prefix, setPrefix] = useState("")
  const [serial, setSerial] = useState("")
  const [search, setSearch] = useState(false)
  const [awbInfo, setAwbInfos] = useState(null)
  const [flights, setFlights] = useState([])
  const [routes, setRoutes] = useState([])
  const [flightInfo, setFlightInfo] = useState(null)
  const [statusInfo, setStatusInfo] = useState([])
  const [stations, setStations] = useState([])
  const [data, setData] = useState(null)
  const [display, setDisplay] = useState(false)
  const [notification, setNotification] = useState(null)
  let {awb} = useParams();

  useEffect(() => {

    setDisplay(false)
    setSearch(false)
    setNotification(null)

    let messages = []

    if(data && data.error && data.noAWBFound){

      messages.push(data.message ? data.message : "")

      setDisplay(false)
      setNotification({
        type : 'warning',
        message : messages,
        notificationTop : true

      })
  
    }else if(data && data.error){

      messages.push(data.message ? data.message : "")

      setDisplay(false)
       setNotification({
        type : 'error',
        message : messages,
        notificationTop : true

      })

    }else if(data && !data.error){

      let {awb_info,status_info, flights, flight_info, routes, stations} = data

      awb_info = awb_info ? awb_info : null
      status_info = status_info ? status_info : []
      flights = flights ? flights : []
      flight_info = flight_info ? flight_info : null
      routes = routes ? routes : []

      setDisplay(true)
      setAwbInfos(awb_info)
      setFlights(flights)
      setStatusInfo(status_info)
      setFlightInfo(flight_info)
      setRoutes(routes)
      setStations(stations)

    }else if(awb){
          
      let error = false
      let prefix = awb.split("-")[0];
      let serial = awb.split("-")[1];

      if(!prefix || isNaN(prefix) ){
        return
      }

      if(prefix.length !== 3){
      
        messages.push('AWB prefix must have 3 digits.')
        error = true
      }

      setPrefix(prefix)
        
      if(!serial || isNaN(serial)) {
        return
      }
      
      if(serial.length !== 8){
        
        messages.push('AWB serial must have 8 digits.')
        error = true
      }

      setSerial(serial)

      if(error){

        setNotification({
          type : 'warning',
          message : messages,
          notificationTop : true
        })

        return
      }

      setSearch(true)

  

    }
  }, [data, props]);


  let lastStatus = statusInfo && statusInfo[0] ? statusInfo[0] : null;
   
  return (

    <div style = {{padding : isMobile ? '1em' : '',}} >
      
      <Favicon url={require("./img/favicon2.png")} />

      <section className="full-width"  style={{background : "white", height :"5.7rem"}}>
        <div style={{margin : "0.3em"}}>
          <a href={config.front}> <img src={config.logo}  alt="logo" /> </a>
        </div>
      </section>
    
     {notification && notification.notificationTop &&
        <Notification notification = {notification} setNotification= {setNotification}/>
     }

     <Search 
        prefix={prefix}
        setPrefix = {setPrefix}
        serial = {serial}
        setSerial = {setSerial}
        setData = {setData}
        setNotification = {setNotification}
        setSearch = {setSearch}
        search = {search}
    />
      
      {display &&
        <>
          <ShipmentInfo 
            awbInfo = {awbInfo}
            lastStatus = {lastStatus}
          />

          <Path
            routes = {routes}
            awbInfo = {awbInfo}
          />

          <FlightDetails 
            flights = {flights}
          />
        
          <StatusInfo
            statusInfo = {statusInfo}
          />
                          
          {notification && notification.notificationBottom &&
            <Notification notification = {notification} setNotification= {setNotification}/>
          }

          <Subscribe 
          prefix = {prefix} 
          serial = {serial}
          statusInfo = {statusInfo}
          setNotification = {setNotification}
          
          />
          
          <FlightMap 
            show={awbInfo && flightInfo} 
            flightInfo = {flightInfo}
            awbInfo = {awbInfo}
            flights = {flights}
            stations = {stations}
          /> 

        </>
      }
      

    </div>
  )

}


export default Main;



